<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_rename_copy_title' | translate }}</h4>
  <form #form="ngForm">
    <mat-form-field floatLabel="always">
      <mat-label>{{ 'dialog_rename_copy_name' | translate }}</mat-label>
      <!-- La racine est dans le champ mais hors du matPrefix : en préfixe, elle décalerait le label avec elle. -->
      <div class="name-field">
        <span class="root">{{ data.rootName }}</span>
        <input matInput [(ngModel)]="data.suffix" cdkFocusInitial name="suffix" [maxlength]="suffixMaxLength" required />
      </div>
      <mat-hint>{{ 'dialog_rename_copy_hint' | translate }}</mat-hint>
      <mat-error *ngIf="!data.suffix" [innerHTML]="'dialog_rename_copy_error_required' | translate"></mat-error>
    </mat-form-field>

    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button (click)="onSubmit()" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
